import Vue from "vue";
import axios from "axios";
import VueLazyload from "vue-lazyload";
import Vant from "vant";
import "vant/lib/index.css";
import vuetify from './plugins/vuetify';

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

import QrcodeVue from 'qrcode.vue';
Vue.component("qrcode-vue", QrcodeVue);

import wcListFooter from "./components/wcListFooter.vue";
Vue.component("wc-list-footer", wcListFooter);
import wcListOptions from "./components/wcListOptions.vue";
Vue.component("wc-list-options", wcListOptions);

import wcSerarch from "./components/wcSearch.vue";
Vue.component("wc-search-box", wcSerarch);

import wcTabbarCart from "./components/wcTabbarCart.vue";
Vue.component("wc-tabbar-cart", wcTabbarCart);

import './registerServiceWorker'

Vue.filter("currency", function (value) {
  //console.log(value);
  let n_value = parseFloat(value);
  /*   if (typeof value !== "number") {
      return value;
    } */
  if (n_value == NaN) {
    return value;
  }
  var formatter = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
  });
  return formatter.format(n_value);
});

// Vue.filter('format_money', {
//   // Model => View
//   read: function (val) {
//      return val; //.toFixed(2);
//   },
//   // View => Model
//   write: function (val, oldVal) {
//     return val;
//     //const number = +val.replace(/[^\d.,]/g, '');
//     //return isNaN(number) ? 0 : parseFloat(number.toFixed(2))
//   }
// })

Vue.use(Vant);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

Vue.prototype.$devMode = (process.env.NODE_ENV === 'development');

// Vue.prototype.$ajax1 = axios.create({
//   // baseURL: 'http://x.mrsdigi.com/da3/webapp.f3/app-dc.php',
//   baseURL: 'https://api.mrsdigi.com/digiCloud/v4.php',
//   // withCredentials: true,
// });

let instance2 = axios.create({
  // baseURL: 'http://x.mrsdigi.com/da3/webapp.f3/app-baby.php',
  // baseURL: 'http://x.mrsdigi.com/da3/webapp.f3/app-test.php',
  //'http://x.mrsdigi.com/da3/webapp.f3/app-test.php' 
  // baseURL: 'https://api.mrsdigi.com/digiHare/baby.php/',
  baseURL: store.state.ioBaseURL,
  withCredentials: true,
});
Vue.prototype.$ajax2 = instance2;

Vue.prototype.$ajaxHeader = {
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
};
Vue.prototype.$ajax2log = (obj) => {
  instance2
    .post("log", obj, { headers: { "Content-Type": "application/json;charset=UTF-8", } })
    .then((rpdata) => { })
    .catch((err) => { }); // eslint-disable-line
};

// Vue.prototype.$ws1host = (Vue.prototype.$devMode ? 'ws://x.mrsdigi.com:8080/notify' : 'ws://api.mrsdigi.com:8080/notify');

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: Vue.prototype.$defaultNotFoundImage, //"./assets/img/img_notfound.png",
  loading: Vue.prototype.$defaultImageLoadingImage, //"./assets/img/img_loading.png",
  attempt: 1,
});

Vue.prototype.$version = "0.1.2";

Vue.prototype.$defaultLogoImage = require("./assets/img/icon_logo_1.png");
Vue.prototype.$defaultImageLoadingImage = require("./assets/img/img_loading.gif");
Vue.prototype.$defaultNoImageImage = require("./assets/img/img_noimage.png");
Vue.prototype.$defaultNotFoundImage = require("./assets/img/img_notfound.png");
Vue.prototype.$defaultShoppingCartImage = require("./assets/img/icon_cart_s.png");
Vue.prototype.$defaultCustomerServocesImage = require("./assets/img/icon_services.png");

// tabs
Vue.prototype.$enableBrands = true;
Vue.prototype.$enableCategories = true;
Vue.prototype.$enableMembership = true;

Vue.prototype.$enableHotBrands = true;
Vue.prototype.$enableHotCategories = true;
Vue.prototype.$enableHotProducts = true;
Vue.prototype.$enableNewProducts = true;
Vue.prototype.$enablePromoProducts = true;

Vue.prototype.$enableCustomerService = false;
Vue.prototype.$enableShoppingCart = true;

//
Vue.prototype.$scrollTop = function () {
  document.body.scrollTop = 0;  // For Safari
  document.documentElement.scrollTop = 0;
};

// test CA/US phone number format
Vue.prototype.$isValidPhoneNumber = function (str) {
  // return /^[1][3,4,5,7,8][0-9]{9}$/.test(str);
  // var regex = /^\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4}) *$/;
  var regex = /^[\+]?[1]?[(]?[2-9]{1}\d{2}[)]?[-\s\.]?[2-9]{1}\d{2}[-\s\.]?[0-9]{4}$/im;
  return regex.test(str);
};
//验证郵箱號
Vue.prototype.$isValidEmail = function (str) {
  //return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(str);
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(str);
};


new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
  computed: {
    // isKeepAlive() {
    //   // console.log(router.currentRoute);
    //   return router.currentRoute.meta && router.currentRoute.meta.keepAlive;
    // },
  },
}).$mount("#app"); // use the id:app
